import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column" }
const _hoisted_2 = ["textContent"]

import { computed } from 'vue';
import { useCalendarStore } from '@/store';


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentedHours',
  setup(__props) {

const hours = computed(() => {
  const totals = useCalendarStore().documentedHours;

  return totals ? `${totals.documented}/${totals.planned}` : '0';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("label", null, "Documented", -1)),
    _createElementVNode("div", {
      class: "hours font-bold align-items-center",
      textContent: _toDisplayString(hours.value)
    }, null, 8, _hoisted_2)
  ]))
}
}

})